import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b87551d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terms-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "terms" }, [
  /*#__PURE__*/_createTextVNode(" By continuing, you’re agreeing to our "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, "Customer Terms of Service, Privacy Policy"),
    /*#__PURE__*/_createTextVNode(",")
  ]),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, "Cookie Policy"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}